/** Shared responsive breakpoints — use across JS and align with mobile-responsive.css */

export const MOBILE_MAX_WIDTH = 768;
export const TABLET_MAX_WIDTH = 900;

export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${MOBILE_MAX_WIDTH + 1}px)`;
export const TABLET_MEDIA_QUERY = `(max-width: ${TABLET_MAX_WIDTH}px)`;

export const isMobileViewport = () =>
  typeof window !== 'undefined' && window.matchMedia(MOBILE_MEDIA_QUERY).matches;

export const isTabletOrBelow = () =>
  typeof window !== 'undefined' && window.matchMedia(TABLET_MEDIA_QUERY).matches;

export const shouldShowMapByDefault = () =>
  typeof window !== 'undefined' && window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
